<template>
  <!-- <div id="app" @scroll.self="handleScroll"> -->
  <div id="app" :class="{'is-v8': version == 'V8'}">
    <Header :navList="navList" :isBgBlack="isBgBlack"></Header>
    <div class="main-container">
      <a-config-provider :locale="local">
        <router-view />
      </a-config-provider>
    </div>
    <div class="side-block">
      <AISeek></AISeek>
      <feed-back></feed-back>
    </div>
  </div>
</template>

<script>
import Header from "./components/HeaderBar.vue";
import zh_CN from "ant-design-vue/es/locale/zh_CN";
import FeedBack from "./components/FeedBack.vue";
import AISeek from "./components/AISeek.vue";
import { getMenu } from '@/api/index.js';

document.title = "致远开放平台";

export default {
  name: "App",
  components: {
    Header,
    FeedBack,
    AISeek
  },
  data() {
    const version = window.localStorage.getItem("openSeeyonVersion");
    const navListStart = version == 'V8' ? [
      {
        key: "home",
        title: "首页",
      },
      {
        key: "faq",
        title: "FAQ(V8)",
      }
    ] : [
      {
        key: "home",
        title: "首页",
      },
      {
        key: "faq",
        title: "FAQ",
      }
    ],navListEnd = [
      {
        key: "updateLog",
        title: "更新日志"
      }
    ]
    return {
      local: zh_CN,
      navListStart,
      navListEnd,
      dynamicNavList: [
        // {
        //   key: "doc",
        //   title: "技术文档",
        //   children: [
        //     {
        //       key: "doc",
        //       title: "技术平台",
        //       link: "v5devCTP",
        //     },
        //     {
        //       key: "doc",
        //       title: "SeeyonAPI",
        //       link: "seeyonapi"
        //     },
        //     {
        //       key: "doc",
        //       title: "集成平台",
        //       link: "v5devCIP",
        //     },
        //     {
        //       key: "doc",
        //       title: "应用平台",
        //       link: "v5devCAP",
        //     },
        //     {
        //       key: "doc",
        //       title: "移动平台",
        //       link: "v5devCMP",
        //     },
        //     {
        //       key: "doc",
        //       title: "前端组件库",
        //       link: "v5devUIComp",
        //       target: "_blank"
        //     },
        //     {
        //       key: "doc",
        //       title: "移动开发文档",
        //       link: "cmpdev",
        //       target: "_blank"
        //     }
        //   ]
        // },
        // {
        //   key: "doc",
        //   title: "系统运维",
        //   link: "v5doc",
        // },
        // {
        //   key: "doc2",
        //   title: "产品文档",
        //   link: "v5doc2",
        // },
        // {
        //   key: "tools",
        //   title: "工具库",
        //   children: [
        //     {
        //       key: "officePlugin",
        //       title: "流版签插件推荐助手",
        //       link: "#/officePlugin",
        //     },
        //     {
        //       key: "envirCheck",
        //       title: "环境检查工具",
        //       link: `${process.env.VUE_APP_supportUrl}/cbo_cptjxx.html?id=1554733797281370113`,
        //       target: "_blank"
        //     },
        //     {
        //       key: "seeyonDump",
        //       title: "SeeyonDump性能自动记录工具",
        //       link: `${process.env.VUE_APP_supportUrl}/cbo_cptjxx.html?id=1802536845696802817`,
        //       target: "_blank"
        //     },
        //     {
        //       key: "officeCheck",
        //       title: "Office控件检测修复工具",
        //       link: `${process.env.VUE_APP_supportUrl}/cbo_cptjxx.html?id=1732642082402603010`,
        //       target: "_blank"
        //     },
        //      {
        //        key: "m3Package",
        //        title: "M3抓包工具",
        //        link: `${process.env.VUE_APP_supportUrl}/cbo_cptjxx.html?id=1844262348932644865`,
        //        target: "_blank"
        //      }
        //   ]
        // }
        //修改文件测试
      ],
      isBgBlack: false,
      version: version
    };
  },
  computed:{
    navList() {
      return this.navListStart.concat(this.dynamicNavList).concat(this.navListEnd)
    },
  },
  created() {
    const _this = this;
    getMenu().then(res => {
      if(res.code === 0) {
        _this.dynamicNavList = res.data.map(item => {
          item.children = item.children.map(item => {
            item.link = `${item.link}`
            return item
          })
          return item
        })
        console.log( _this.dynamicNavList,11111)
      }
    })
  },
  methods: {
    handleScroll(e) {
      var target = e.target || e.secElement;
      var scrollTop = target ? target.scrollTop : 0;
      if (scrollTop > 0) {
        this.isBgBlack = true;
      } else {
        this.isBgBlack = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.is-v8 ::v-deep{
  background: #000;
  .header-nav,.footer{
    background: #000;
    color: #fff;
  }
  .extral-link,.logo-text{
    color: #fff;
  }
  .footer .footer-content a{
    color: #fff;
  }
  .home-page-container{
    background: center / cover url(./assets/imgs/v8-bg.jpg) no-repeat;
  }
  .banner{
    padding-top: 45vh;
    margin: 0 auto;
    &-content{
      left: 0;
      top: 36%;
    }
    .platform-name{
      font-size: 70px;
      color: #fff;
    }
    .platform-description{
      color: #fff;
      max-width: 32vw;
      // margin-top: 2%;
    }
  }
  .search-module .search-cmp{
    box-shadow: 0px 0px 24px 0px rgba(0,0,0,0.50); 
    .ant-input-group-addon .ant-btn-lg,
    .ant-input {
      border: 1px solid rgba(255,255,255,0.20) !important;
    }
    .ant-input{
      background: rgba(255,255,255,0.04);
    }
  }
  
  @media screen and (max-width: 1440px) {
    .banner{
    
      .platform-name{
        font-size: 52px;
      }
      // .platform-description{
      //   max-width: 50vw;
      //   margin-top: 2%;
      // }
    }
  }
  
  
  @media screen and (max-width: 1024px) {

    .home-page{
      &-container{ 
        background: 50% 70% / cover url(./assets/imgs/v8-bg-m.jpg) no-repeat;
      }
      .banner{
        padding-top: 34vh;
        &-content{ 
          right: 0;
        }
      }
      .platform-description{
        max-width: 100%;
        margin-top: 10px;
        transform: scale(1);
      }
      .platform-name{
        transform: scale(1);
      }
    }
  }
  
  @media screen and (max-width: 824px) {
    .home-page-container{ 
      background-position: 50% 80%;
    }
    .nav-list,.extral-link{
      color: #000;
    }
    .banner{
      .platform-description{
        max-width: 100%;
        margin-top: 10px;
        text-align: center;
      }
      .platform-name{
        text-align: center;
      }
    }
  }
}

</style>
<style>
html,
body,
#app {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  /* min-width: 1110px; */
  overflow: auto;
  background: #f6f6f6;
  font-family: 'PingFang SC', 'Microsoft YaHei';
}
#app {
   overflow-x: hidden; 
}
.main-container {
  width: 100%;
  height: calc(100% - 56px);
  margin-top: 56px;
  background: #f6f6f6;
}
.side-block{
  position: fixed;
  z-index: 999;
  right: 1.2%;
  bottom: 10%;
}
.ant-btn-primary{
  background-color: #007AFF;
  border-color: #007AFF;
}
::-webkit-scrollbar-track-piece {
  background-color: #f8f8f8;
}
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
::-webkit-scrollbar-thumb {
  background-color: #dddddd;
  background-clip: padding-box;
  border-radius: 6px;
  min-height: 28px;
}
::-webkit-scrollbar-thumb:hover {
  background-color: #bbb;
}
</style>
